<template>
  <div class="instagram-feed">
    <!-- <map-loc :attributes="attributes"/> -->
    <st-loading class="feed-loading" v-if="!hasFetchedHashtag"/>
    <div v-for="(post, i) in orderedPosts" :key="i" class="post" v-if="!post.is_ad" :data-postid="post.id" @click="showDetails(post)">
      <img class="preview" :src="post.display_resources[0].src" />
      <img v-if="post.is_video" class="btn-video" :src="getSource('project/play-icon.svg')" />
      <div v-if="post.__typename === 'GraphSidecar'" class="album-icon"><img :src="getSource('project/album.svg')" /></div>
      <div class="user" v-html="post.owner.username === 'straits_times' ? post.owner.full_name : post.owner.username" />
      <div class="text" v-if="post.edge_media_to_caption.edges[0]" v-html="truncateStr(post.edge_media_to_caption.edges[0].node.text)" />
    </div>
    <div class="view-more"><a :href="'https://www.instagram.com/explore/tags/' + hashtag" @click="onViewMoreClick">View More</a></div>
    <popUp :postDetail="postDetail" @close="closeDetails"/>
  </div>
</template>

<script>
import _find from 'lodash/find'
import _orderBy from 'lodash/orderBy'
import _truncate from 'lodash/truncate'
import popUp from './popup.vue'
import stLoading from '../../StLoading.vue'
import mapLoc from './map.vue'

export default {
  props: ['attributes'],
  components: {
    popUp,
    stLoading,
    mapLoc
  },
  data () {
    return {
      posts: [],
      blocked_posts: [],
      isFirstLoad: true,
      fetchFrequency: 63000,
      showPop: false,
      postDetail: {},
      hashtag: '',
      hasFetchedHashtag: false
    }
  },
  computed: {
    orderedPosts: function () {
      return _orderBy(this.posts, 'taken_at_timestamp', 'desc')
    }
  },
  methods: {
    getSource (value) {
      if (!value) return null
      return require(`images/${value}`)
    },
    onViewMoreClick () {
      this.$analytics.getClient('ndp-instagram-2020').track('click', 'btn-view-more')
    },
    showDetails (post) {
      setTimeout(() => {
        this.postDetail = post
        this.showPop = true
      }, 300)
    },
    closeDetails () {
      this.postDetail = {}
      this.showPop = false
    },
    truncateStr (str) {
      return _truncate(str, {
        length: 200,
        separator: ' ',
        omission: ' ...'
      })
    },
    fetchFeed () {
      const self = this
      fetch(`https://www.instagram.com/explore/tags/${self.hashtag}/?__a=1`, {
        method: 'GET',
        cache: 'no-cache'
      })
      .then((resp) => resp.json())
      .then((data) => {
        self.hasFetchedHashtag = true
        data.graphql.hashtag.edge_hashtag_to_media.edges.forEach((item, i) => {
          if (!_find(self.posts, ['id', item.node.id]) && !self.blocked_posts.includes(item.node.id)) {
            fetch(`https://www.instagram.com/p/${item.node.shortcode}/?__a=1`, {
              method: 'GET',
              cache: 'force-cache'
            })
            .then((respdata) => respdata.json())
            .then((itemdata) => {
              // if (itemdata.graphql.shortcode_media.location) {
              //   const address = JSON.parse(itemdata.graphql.shortcode_media.location.address_json)
              //   // console.log(address.street_address +'--'+address.zip_code+'=='+address.region_name)
              // }
              if (!itemdata.graphql.shortcode_media.edge_media_to_caption.edges.length) {
                // hashtags is in the later comment
                const comment = _find(itemdata.graphql.shortcode_media.edge_media_preview_comment.edges, function (o) {
                  return o.node.text.toLowerCase().includes('#' + self.hashtag)
                })
                if (comment) {
                  itemdata.graphql.shortcode_media.edge_media_to_caption.edges.push(comment)
                }
              }
              if (self.isFirstLoad) {
                self.posts.push(itemdata.graphql.shortcode_media)
              } else {
                self.posts.unshift(itemdata.graphql.shortcode_media)
              }
              if (i === data.graphql.hashtag.edge_hashtag_to_media.edges.length - 1) {
                setTimeout(() => {
                  self.isFirstLoad = false
                  self.fetchBlockedPosts()
                  self.fetchFeed()
                }, self.fetchFrequency)
              }
            })
            .catch((err) => {
              console.log('No instagram post details', err)
            })
          } else {
            if (!self.blocked_posts.includes(item.node.id)) {
              // show unblocked id
              try {
                const article = self.$el.querySelector(`[data-postid="${item.node.id}"]`)
                if (article && article.style.display !== 'inline-block') {
                  article.style.display = 'inline-block'
                }
              } catch (error) { }
            }
            if (i === data.graphql.hashtag.edge_hashtag_to_media.edges.length - 1) {
              setTimeout(() => {
                self.isFirstLoad = false
                self.fetchBlockedPosts()
                self.fetchFeed()
              }, self.fetchFrequency)
            }
          }
        })
      })
      .catch((err) => {
        self.hasFetchedHashtag = true
        console.log('Error fetching instagram', err)
      })
    },
    fetchBlockedPosts () {
      // fetch longform json
      const self = this
      const fetch = process.env.IS_PREMIUM
        ? self.$premium.fetchContent(process.env.PAGES.index.resource)
        : self.$premium.fetchPublicContent(process.env.PAGES.index.resource)

      return fetch.then(response => {
        if (response) {
          _find(response, function (o, key) {
            if (key === 'sections') {
              const chapter = _find(o[0].components, {'type': 'instagramfeed'})
              self.blocked_posts = chapter ? chapter.value.blocked_ids : self.blocked_posts

              // hide from DOM
              self.blocked_posts.forEach((id, i) => {
                if (self.$el.children.length) {
                  try {
                    const article = self.$el.querySelector(`[data-postid="${id}"]`)
                    if (article) {
                      article.style.display = 'none'
                    }
                  } catch (error) { }
                }
              })
              return true
            }
            return false
          })
        }
      })
    }
  },
  mounted () {
    this.hashtag = this.attributes.value.hashtag.replace('#', '')
    this.$loading.withLoading(this.fetchFeed)()
    this.blocked_posts = this.attributes.value.blocked_ids
    // this.fetchFeed()
  }
}
</script>
<style lang="scss" scoped>
  .instagram-feed {
    max-width: 1340px;
    margin: 0 auto;
    text-align: center !important;
    .feed-loading.st-loading-container {
      background-color: rgba(255, 255, 255, 0.5) !important;
    }
  }
  .post {
    width: 100%;
    height: 480px;
    display: inline-block;
    padding: 20px 10px;
    overflow: hidden;
    max-width: 38vw;
    position: relative;
    text-align: left;
    cursor: pointer;
    vertical-align: top;
    &:hover {
      .btn-video {
        opacity: 1;
      }
    }
    .preview {
      width: 38vw;
      height: 38vw;
      object-fit: cover;
      border-radius: 10px;
    }
    .btn-video {
      position: absolute;
      left: 50%;
      top: 150px;
      width: 60px;
      transform: translateX(-50%);
      opacity: 0.6;
      transition: opacity .15s ease-out;
    }
    .album-icon {
      position: absolute;
      top: 35px;
      right: 20px;
      font-weight: bold;
      width: 25px;
    }
    .user {
      display: block;
      font-family: $font-CuratorBold;
      font-size: 16px;
      color: #333;
      padding: 10px 0;
    }
    .text {
      display: block;
      font-size: 16px;
      color: #333;
      font-family: $font-CuratorRegular;
      word-break: break-word;
    }
    @include breakpoint($d_medium) {
      max-width: 300px;
      padding: 30px 10px;
      .preview {
        width: 300px;
        height: 300px;
      }
    }
  }
  .view-more {
    padding-top: 30px;
    a {
      display: inline;
      outline: none;
      padding: 5px 25px;
      border: 1px solid rgba(12,43,87,.5);
      background-color: transparent;
      border-radius: 25px;
      color: #333;
      text-decoration: none;
      font-family: $font-CuratorRegular;
      text-align: center;
      font-size: 15px;
      transition: border .15s ease-out;
      &:hover {
        border: 1px solid #333;
      }
    }
  }
</style>
